module.exports = __webpack_public_path__ + "img/95.c24a861c.jpg";